var map = {
	"./img-shop-food-0.png": "7d44",
	"./img-shop-food-1.png": "f59b",
	"./img-shop-food-2.png": "c111",
	"./img-shop-food-3.png": "4967",
	"./img-shop-food-5.png": "5399"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "693c";